import type { FormLayout, FormLayoutPage } from '../../../../../forms'
import { BasicInfoLayout } from './basic-info'
import { buildLayoutWithCommonSections, layoutFields } from './helpers'
import { NotesLayout } from './notes'

const LulaLayout: FormLayoutPage = {
  key: 'lula',
  title: 'LULA',
  contents: [
    layoutFields.speed,
    layoutFields.condition,
    layoutFields.accumulatedWear,
    layoutFields.design,
    layoutFields.inherentQuality,
    layoutFields.usage,
    layoutFields.environment,
    layoutFields.technology,
    layoutFields.drivingMachineInstallYear,
    layoutFields.operationalControllerInstallYear,
    layoutFields.typeOfMotorController,
    layoutFields.hasCounterweightSafeties,
    layoutFields.hasMGSet,
    layoutFields.governorType,
    layoutFields.acopumdType,
    layoutFields.driveType,
    layoutFields.brakeType,
    layoutFields.hasNonMetallicSheaveLiner,
    layoutFields.hasCoatedRopes,
    layoutFields.hasTractionLossDetection,
    layoutFields.hasBrokenSuspensionDetection,
    layoutFields.hasEmergencyPower,
    layoutFields.isMachineRoomLess,
    layoutFields.execSoftwareRevision,
    layoutFields.controllerManufacturerAndModel,
    layoutFields.drivingMachineManufacturerAndModel,
    layoutFields.carsShareMachineRoom,
    layoutFields.suspensionMembersInstallYear,
    layoutFields.interlocksInstallYear,
    layoutFields.typeOfDoorOperator,
    layoutFields.doorRestrictorType,
    layoutFields.suspensionMeansType,
    layoutFields.hasSeismicDevices,
    layoutFields.hasBrokenRopeSelectorSwitch,
    layoutFields.guideType,
    layoutFields.doorOperatorManufacturerAndModel,
    layoutFields.hoistwayDoorType,
    layoutFields.carDoorType,
    layoutFields.numLandings,
    layoutFields.numberOfOpenings,
    layoutFields.doorOpeningMethod,
    layoutFields.doorPanelsType,
    layoutFields.hasHoistwayAccess,
    layoutFields.hasFirefighterService,
    layoutFields.isObservationElevator,
    layoutFields.hasVisionPanels,
    layoutFields.bufferType,
    layoutFields.hasBufferSwitches,
    layoutFields.hasCompensation,
    layoutFields.hasCompensationSheave,
    layoutFields.numCarsSharePit,
  ],
}

export const LulaFormLayout: FormLayout = buildLayoutWithCommonSections([
  BasicInfoLayout,
  LulaLayout,
  NotesLayout,
])
